const { useEffect, useRef } = require('react');

exports.useRouteScrollRestoration = function useRouteScrollRestoration({ rememberScroll, restoreScroll, shouldRestore = true }) {

    const shouldRestoreOnMount = useRef(shouldRestore).current;

    useEffect(() => {

        if (shouldRestoreOnMount) {
            restoreScroll();
        }

        return () => rememberScroll();
    }, [rememberScroll, restoreScroll, shouldRestoreOnMount]);
};
